import { render, staticRenderFns } from "./DeliveryPrice.vue?vue&type=template&id=602fd42d&scoped=true"
import script from "./DeliveryPrice.vue?vue&type=script&lang=js"
export * from "./DeliveryPrice.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPrice.vue?vue&type=style&index=0&id=602fd42d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602fd42d",
  null
  
)

export default component.exports